import {appI18n} from "@/i18n";

export const splitByString = (str: string, param = '#'): string[] => {
  return str.split(param)
}

export const splitByStringAndTranslate = (str: string, param = '#', removeChar = '%', func = (s: string) => {return s}): string[] => {
  return str.split(param).map(str => func(str.replaceAll(removeChar, '')));
}
